// src/services/converters/firestoreConverters.ts

import { Rate, RatePagata, RateRiscaldamento, RateRiscaldamentoPagata } from "../types/firestoreTypes";
import { DocumentSnapshot } from "firebase/firestore";

// helper to parse Italian-style numbers (e.g. "1.234,56" → 1234.56)
const parseNumber = (s: unknown): number => {
  if (typeof s !== "string") return 0;
  return Number(s.replace(/\./g, "").replace(/,/g, ".")) || 0;
};

// helper to parse boolean from "FALSO"/"VERO"
const parseBool = (s: unknown): boolean => {
  if (typeof s !== "string") return false;
  return /^vero$/i.test(s.trim());
};

/** Convert a Firestore document into an unpaid ordinary Rate */
export function toRate(doc: DocumentSnapshot): Rate {
  const data = doc.data() as Record<string, any>;
  return {
    id: doc.id,
    cod_con: data.cod_con,
    cod_condomino: data.cod_condomino,
    data_scad: data.data_scad,
    imp_tot: parseNumber(data.imp_tot),
    inviato_mail: parseBool(data.inviato_mail),
    num_prev: parseNumber(data.num_prev),
    num_rata: parseNumber(data.num_rata),
    tipo_rata: data.tipo_rata,
  };
}

/** Convert a Firestore document into a paid ordinary RatePagata */
export function toRatePagata(doc: DocumentSnapshot): RatePagata {
  const data = doc.data() as Record<string, any>;
  return {
    id: doc.id,
    cod_con: data.cod_con,
    cod_condomino: data.cod_condomino,
    data_reg: data.data_reg,
    imp_tot: parseNumber(data.imp_tot),
    num_prev: parseNumber(data.num_prev),
    num_rata: parseNumber(data.num_rata),
    num_reg: parseNumber(data.num_reg),
    progressivo_registrazione: parseNumber(data.progressivo_registrazione),
    tipo_rata: data.tipo_rata,
    tipo_vers: data.tipo_vers,
  };
}

/** Convert a Firestore document into an unpaid heating RateRiscaldamento */
export function toRateRiscaldamento(doc: DocumentSnapshot): RateRiscaldamento {
  const data = doc.data() as Record<string, any>;
  return {
    id: doc.id,
    cod_con: data.cod_con,
    cod_ui: data.cod_ui,
    data_scad: data.data_scad,
    imp_tot: parseNumber(data.imp_tot),
    inviato_mail: parseBool(data.inviato_mail),
    num_prev: parseNumber(data.num_prev),
    num_rata: parseNumber(data.num_rata),
  };
}

/** Convert a Firestore document into a paid heating RateRiscaldamentoPagata */
export function toRateRiscaldamentoPagata(
  doc: DocumentSnapshot
): RateRiscaldamentoPagata {
  const data = doc.data() as Record<string, any>;
  return {
    id: doc.id,
    cod_con: data.cod_con,
    cod_ui: data.cod_ui,
    data_reg: data.data_reg,
    imp_tot: parseNumber(data.imp_tot),
    num_prev: parseNumber(data.num_prev),
    num_rata: parseNumber(data.num_rata),
    num_reg: parseNumber(data.num_reg),
    progressivo_registrazione: parseNumber(data.progressivo_registrazione),
    tipo_vers: data.tipo_vers,
  };
}